module.exports = __webpack_public_path__ + "assets/205e9b239e9f610e55c098e080c4964e.png";